import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-group email" }
const _hoisted_2 = { class: "input-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("form", {
    class: "account-login",
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseInput, {
        type: "email",
        label: "Enter your e-mail address",
        placeholder: "E-mail address",
        hasError: _ctx.v$.email.$error,
        errors: _ctx.v$.email.$errors,
        valid: !_ctx.v$.email.$invalid,
        modelValue: _ctx.state.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.email) = $event))
      }, null, 8, ["hasError", "errors", "valid", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BaseButton, { loading: _ctx.loading }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Next")
        ])),
        _: 1,
        __: [2]
      }, 8, ["loading"])
    ])
  ], 32))
}